import styled, { css } from "styled-components";
import { ElementGroup, Title } from "styles/components";
import { PopupType } from "../PopupType";
import { useAbsPopupButton, usePopupData } from "commons/popup/store/absPopupHook";
import Button from "components/ui/Button";
import { ButtonType } from "components/ComponentsType";
import type { IAlarmtalkPopUpData } from "./AlarmtalkVo";
import AbsPopup from "commons/popup/display/AbsPopup";
import { UiCheckBox } from "commons/components/CheckBox";
import { useAlarmPartnersListInit, useAlarmSendOut } from "./AlarmtalkHook";
import { ButtonState } from "commons/popup/store/absPopupVo";

const TitleDiv = styled.div`
  width: 100%;
  padding: 10px 0;
  height: 28px;
  h3 {
    margin-bottom: 0;
    font-size: 1.2rem;
    font-weight: 500;
    text-align: center;
  }
`;

const ContentDiv = styled.div`
  padding: 4px 10px;
  border: 1px solid #d6d6d6;
  height: auto;
  max-height: 500px;
  overflow-y: scroll;

  .all {
    padding: 3px 0;
    border-bottom: 1px solid var(--border-normal);
    label {
      font-weight: 500;
    }
  }
  label {
    cursor: pointer;
    margin: 7px 0;
    font-size: 14px;
  }
`;
const FooterStyle = styled(ElementGroup.Row)`
  padding: 0px 18px 10px 18px;
`;

const AlarmListWrap = styled.div<{ type: "CP" | "PP" | "PN" }>`
  width: 100%;
  display: flex;
  align-items: center;
  color: #444;
  .type {
    margin-left: 6px;
    padding: 0 4px;
    border-radius: 4px;
    font-size: 0.7rem;
    line-height: 1rem;
    border: 1px solid #dedede;
    ${props => {
      switch (props.type) {
        case "CP":
          return css`
            border-color: var(--primary);
            color: var(--primary);
          `;
        case "PN":
          return css`
            border-color: #974f0c;
            color: #974f0c;
          `;
        default:
          return css`
            border-color: #e54c95;
            color: #e54c95;
          `;
      }
    }}
  }
`;

export function AlarmButtonGroup() {
  const { popupDo } = usePopupData<IAlarmtalkPopUpData>(PopupType.ALARM_TALK_POPUP);
  const { close } = useAbsPopupButton(PopupType.ALARM_TALK_POPUP);
  const { sendOut } = useAlarmSendOut(popupDo.data);
  return (
    <FooterStyle flexContent="between">
      <Button text="취소" thin btnSize={"sm"} btnType={ButtonType.BORDER} onClick={close.bind(null, ButtonState.NO)} />
      <Button
        text="알림톡 보내기"
        thin
        btnSize={"sm"}
        color={"secondary"}
        onClick={() => {
          sendOut();
        }}
      />
    </FooterStyle>
  );
}

function PopupHeader(props: { title?: string }) {
  return (
    <TitleDiv>
      <Title weight="regular">{`${props.title} 알림톡`}</Title>
    </TitleDiv>
  );
}

export default function AlarmtalkPopup(): JSX.Element {
  const { popupDo } = usePopupData<IAlarmtalkPopUpData>(PopupType.ALARM_TALK_POPUP);
  const { partnerList } = useAlarmPartnersListInit(popupDo.data!);

  return (
    <AbsPopup type={PopupType.ALARM_TALK_POPUP} borderShape={4} header={<PopupHeader title={popupDo.title} />}>
      <ContentDiv>
        {partnerList && (
          <>
            <div className="all">
              <UiCheckBox id="isAll" name={`${popupDo.data?.list_type}_alarmtalk`} text={"전체 선택"} />
            </div>

            {partnerList.map((i, idx) => {
              return (
                <AlarmListWrap key={idx} type={i.type}>
                  <UiCheckBox id={i.code} name={`${popupDo.data?.list_type}_alarmtalk`} text={i.name} />
                  <p className="type">{i.type}</p>
                </AlarmListWrap>
              );
            })}
          </>
        )}
      </ContentDiv>
    </AbsPopup>
  );
}
